import { Box, NumberBadge, Prose, Tag, Text } from '@factorialco/deprecated-design-system'
import { TrainingRequestAgreementItemFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  trainingRequest: TrainingRequestAgreementItemFragment
  index: number
}

export const TrainingRequestItem = ({ trainingRequest, index }: Props) => {
  const competencies = trainingRequest?.training?.competencies ?? []

  return (
    <Box width="full" flexDirection="row" gap="s24">
      <NumberBadge label={index} />
      <Box width="full" gap="s8">
        <Box width="fit-content">
          <Tag leftItem="icon" icon="trainings" type="viridian">
            {i18n.t('performance_process.targets.courses_items.course')}
          </Tag>
        </Box>
        <Box flexDirection="row" gap="s12">
          <Prose markdown>
            {trainingRequest?.training?.name ?? String(trainingRequest?.trainingName ?? '')}
          </Prose>
        </Box>
        {competencies.length > 0 && (
          <Box flexDirection="row" gap="s12">
            <Prose markdown>
              {i18n.t('performance_process.targets.courses_items.competencies')}
            </Prose>
            <Prose markdown>
              {competencies.map((competency) => String(competency.name)).join(', ')}
            </Prose>
          </Box>
        )}
        <Box flexDirection="row" gap="s12">
          <Text.Normal color="grey700" size="200">
            {i18n.t('performance_process.targets.courses_items.requested_by', {
              name: trainingRequest.author?.fullName,
            })}
          </Text.Normal>
          <Text.Normal color="grey700" size="200">
            {dateToString(moment(trainingRequest.createdAt), 'ui_dmy_long')}
          </Text.Normal>

          <Text.Normal color="grey700" size="200">
            {i18n.t('performance_process.targets.courses_items.status', {
              status: trainingRequest.status,
            })}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}
